import $ from 'jquery';
async function getDeviceInfo(captureFor,deviceName) {

        if(deviceName=="MORPHO"){
            Capture(deviceName,1)
            return;
        }

        if(deviceName=="MANTRA"){
            Capture(deviceName,1)
            return;
        }

        var url = "http://127.0.0.1:11100/rd/info";
        let captureData;
        var xhr;
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return version number
        {
        //IE browser
            xhr = new ActiveXObject("Microsoft.XMLHTTP");
        } else {
        //other browser
            xhr = new XMLHttpRequest();
        }

        //
        xhr.open('DEVICEINFO', url, true);
        let result = new Promise(xhr.onreadystatechange = function (){
            if (xhr.readyState == 4){
                var status = xhr.status;

                if (status == 200) 
                {
                    let parser=new DOMParser();
                    let xml = parser.parseFromString(xhr.response,"application/xml");
                    var deviceInfo=xml.getElementsByTagName('DeviceInfo')[0]; 
                    var additional_info = deviceInfo.getElementsByTagName('additional_info')[0];
                    var Param = additional_info.getElementsByTagName('Param')[0];
                    var name = additional_info.getElementsByTagName('Param')[0].getAttribute("name");
                    var value = additional_info.getElementsByTagName('Param')[0].getAttribute("value");
                        if(value==''|| value==null)
                        {
                            alert("Device is not ready");
                            return false;
                        }
                        $("#fingerPrintDeiveId").val(value);
                        if(captureFor == "KYC"){
                            kycCapture('MANTRA',value)
                        }else{
                            Capture(deviceName,value)
                        }
                    
                } else {
                    console.log(xhr.response);
                    return 0;
                }
            }

        });

        xhr.send();

}



async function Capture(deviceName,deviceId){

        if(deviceName=="MANTRA")
                {
                    console.log("Mantra Device Activated");
                    var urlnew="http://127.0.0.1:11100/rd/capture";
                    //var XML='<?xml version="1.0"?> <PidOptions version="1.0"> <Opts fCount="1" fType="0" iCount="0" pCount="0" format="0"   pidVer="0" timeout="10000" wadh="" posh="" env="X" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts> </PidOptions>';
                    var XML='<?xml version="1.0"?> <PidOptions version="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0"   pidVer="2.0" timeout="10000" wadh="" posh="" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts> </PidOptions>';
                    //var XML='<PidOptions ver="1.0"> <Opts fCount="1" fType="0" iCount="0" pCount="0" format="1" pidVer="2.0" timeout="20000" otp="" posh="UNKNOWN" env="P"/> <Demo></Demo></PidOptions>';
                }
                else if(deviceName=="MORPHO")
                {
                    console.log("Morpho Device Activated");
                    var urlnew="http://127.0.0.1:11100/capture";
                    // var urlnew="http://127.0.0.1:11100/rd/capture";
                    // XML='<PidOptions ver=\"1.0\">'+'<Opts fCount=\"1\" fType=\"0\" iCount=\"\" iType=\"\" pCount=\"\" pType=\"\" format=\"0\" pidVer=\"2.0\" timeout=\"10000\" otp=\"\" wadh=\"\" posh=\"\"/>'+'</PidOptions>';
                    var XML = `<PidOptions> <Opts fCount='1' fType='2' iCount='0' pCount='0'  format='0' pidVer='2.0' timeout='20000' otp='' posh='UNKNOWN' env='P' wadh='' /> <Demo></Demo>  </PidOptions>`;
                }
                var xhr;//=createCORSRequest('CAPTURE',url);
                var ua = window.navigator.userAgent; 
                var msie = ua.indexOf("MSIE");
                if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return version number
                {
        //IE browser
                    xhr = new ActiveXObject("Microsoft.XMLHTTP");
                } else {
        //other browser
                    xhr = new XMLHttpRequest();
                }
                xhr.open('CAPTURE', urlnew, true);
                xhr.setRequestHeader("Content-Type", "text/xml");
                xhr.setRequestHeader("Accept", "text/xml");
                if (!xhr) 
                {
                    console.log('CORS not supported');
                    return
                }

                 xhr.onreadystatechange = function () {

                    if (xhr.readyState == 4) 
                    {
                        var status = xhr.status;
                        if (status == 200) 
                        {
                            xhr.response
                            $("#fingerPrintBiometicData").val(xhr.response)
                            let parser=new DOMParser();
                            let xml = parser.parseFromString(xhr.response,"application/xml");
                            var pidContent=xml.getElementsByTagName('PidData')[0]; 
                            var responseCode = pidContent.getElementsByTagName('Resp')[0].getAttribute("errCode");
                            var errInfo = pidContent.getElementsByTagName('Resp')[0].getAttribute("errInfo");
                            var captureQuality = pidContent.getElementsByTagName('Resp')[0].getAttribute("qScore");
                            $("#fingerPrintCaptureQuality").val(captureQuality);

                            var ci = pidContent.getElementsByTagName('Skey')[0].getAttribute("ci");
                            var dc = pidContent.getElementsByTagName('DeviceInfo')[0].getAttribute("dc");
                            var dpId = pidContent.getElementsByTagName('DeviceInfo')[0].getAttribute("dpId");
                            var mc = pidContent.getElementsByTagName('DeviceInfo')[0].getAttribute("mc");
                            var mi = pidContent.getElementsByTagName('DeviceInfo')[0].getAttribute("mi");
                            var rdsId = pidContent.getElementsByTagName('DeviceInfo')[0].getAttribute("rdsId");
                            var rdsVer = pidContent.getElementsByTagName('DeviceInfo')[0].getAttribute("rdsVer");
                            var sKey = pidContent.getElementsByTagName('Skey')[0].childNodes[0];
                            var nmPoints = pidContent.getElementsByTagName('Resp')[0].getAttribute("nmPoints");
                            var qScore = pidContent.getElementsByTagName('Resp')[0].getAttribute("qScore");
                            var errCode = pidContent.getElementsByTagName('Resp')[0].getAttribute("errCode");
                            var fCount = pidContent.getElementsByTagName('Resp')[0].getAttribute("fCount");
                            var fType = pidContent.getElementsByTagName('Resp')[0].getAttribute("fType");
                            var hmac = pidContent.getElementsByTagName('Hmac')[0].childNodes[0];
                            var iCount = null;
                            var pid = pidContent.getElementsByTagName('Data')[0].childNodes[0];
                            var errInfo = pidContent.getElementsByTagName('Resp')[0].getAttribute("errInfo");

                            var s = new XMLSerializer();
                            var srlzSkey = s.serializeToString(sKey);
                            var srlzHmac = s.serializeToString(hmac);
                            var srlzPidData = s.serializeToString(pid);

                            var BioData = {
                                ci: ci,
                                dc: dc,
                                dpId: dpId,
                                mc: mc,
                                mi: mi,
                                pid:srlzPidData,
                                rdsId: rdsId,
                                rdsVer: rdsVer,
                                sKey: srlzSkey,
                                nmPoints: nmPoints,
                                qScore: qScore,
                                errCode: errCode,
                                fCount: fCount,
                                fType: fType,
                                hmac: srlzHmac,
                                iCount: iCount,
                                errInfo: errInfo
                            }

                            $("#bioDataJson").val(JSON.stringify(BioData));


                            if(responseCode==700 || responseCode=="700")
                            {
                                alert(errInfo +" Please try again");
                                return false;
                            }
                            else if(responseCode== -1509 || responseCode=="-1509")
                            {
                                alert(errInfo +" Please try again");
                                return false;
                            } 
                            else if(responseCode !=0)
                            {
                                var errorMessage = errInfo +" Please try again";
                                alert(errorMessage)
                                return false;
                            }
                        }
                    }

                };

                xhr.send(XML);
}

async function kycCapture(deviceName,deviceId){

    if(deviceName=="MANTRA")
            {
                var urlnew="http://127.0.0.1:11100/rd/capture";
                var XML='<PidOptions ver=\"1.0\"><Opts env=\"P\" fCount=\"1\" fType=\"2\" iCount=\"0\" format=\"0\" pidVer=\"2.0\" timeout=\"15000\" wadh=\"E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=\" posh=\"UNKNOWN\" /></PidOptions>';
            }
            else if(deviceName=="MORPHO")
            {
                var urlnew="http://127.0.0.1:11100/capture";
                XML='<PidOptions ver=\"1.0\">'+'<Opts fCount=\"1\" fType=\"2\" iCount=\"\" iType=\"\" pCount=\"\" pType=\"\" format=\"0\" pidVer=\"2.0\" timeout=\"10000\" otp=\"\" wadh=\"\" posh=\"\"/>'+'</PidOptions>';
            }
            var xhr;//=createCORSRequest('CAPTURE',url);
            var ua = window.navigator.userAgent; 
            var msie = ua.indexOf("MSIE");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return version number
            {
    //IE browser
                xhr = new ActiveXObject("Microsoft.XMLHTTP");
            } else {
    //other browser
                xhr = new XMLHttpRequest();
            }
            xhr.open('CAPTURE', urlnew, true);
            xhr.setRequestHeader("Content-Type", "text/xml");
            xhr.setRequestHeader("Accept", "text/xml");
            if (!xhr) 
            {
                console.log('CORS not supported');
                return
            }

             xhr.onreadystatechange = function () {

                if (xhr.readyState == 4) 
                {
                    var status = xhr.status;
                    if (status == 200) 
                    {
                        xhr.response
                        $("#fingerPrintBiometicData").val(xhr.response)
                        let parser=new DOMParser();
                        let xml = parser.parseFromString(xhr.response,"application/xml");
                        var pidContent=xml.getElementsByTagName('PidData')[0]; 
                        var responseCode = pidContent.getElementsByTagName('Resp')[0].getAttribute("errCode");
                        var errInfo = pidContent.getElementsByTagName('Resp')[0].getAttribute("errInfo");
                        if(responseCode==700 || responseCode=="700")
                        {
                            alert(errInfo +" Please try again");
                            return false;
                        }
                        else if(responseCode== -1509 || responseCode=="-1509")
                        {
                            alert(errInfo +" Please try again");
                            return false;
                        } 
                        else if(responseCode !=0)
                        {
                            var errorMessage = errInfo +" Please try again";
                            alert(errorMessage)
                            return false;
                        }
                    }
                }

            };

            xhr.send(XML);
}


export {
    getDeviceInfo,
    Capture,
    kycCapture
}